// Auto-generated normalizer for table: Cat_Usuarios
export function catUsuariosNormalize(row) {
  return {
    idUsuario: row.idUsuario ?? row.IdUsuario ?? row['IdUsuario'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    nombreUsuario: row.nombreUsuario ?? row.NombreUsuario ?? row['NombreUsuario'] ?? '',
    contrasenaHASH: row.contrasenaHASH ?? row.ContrasenaHASH ?? row['ContrasenaHASH'] ?? '',
    salt: row.salt ?? row.Salt ?? row['Salt'] ?? '',
    fechaAlta: row.fechaAlta ?? row.FechaAlta ?? row['FechaAlta'] ?? null,
    ultimoAcceso: row.ultimoAcceso ?? row.UltimoAcceso ?? row['UltimoAcceso'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    bloqueadoHasta: row.bloqueadoHasta ?? row.BloqueadoHasta ?? row['BloqueadoHasta'] ?? null,
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row['IdEmpresa'] ?? null,
  };
}
